import {
    DEFAULT_PAGE_COUNT,
    ratingColors,
    gradeColors,
    borderRatingColors,
    ratingText,
    BORDER_START,
    BORDER_ROOT,
    BORDER_SCENE,
    BORDER_WIDTH,
    badge,
    wrap
  } from './Constants';
import { METRIC_KEYS } from './Constants';


  // Assign default page counts where missing
    function preprocessScenes(ratings) {
        // For each act
        ratings.acts.forEach(act => {
          // For each sequence in the act
          act.sequences.forEach(sequence => {
            // Check if scenes array exists
            if (!sequence.scenes) {
              sequence.scenes = [];
            }
            
            // Assign default page count to scenes that don't have one
            sequence.scenes.forEach(scene => {
              if (!scene.page_count) {
                scene.page_count = DEFAULT_PAGE_COUNT;
              } else {
                // Convert to number if it's a string
                scene.page_count = parseFloat(scene.page_count);
              }
            });
          });
        });
      }

      function formatLabel(node) {
        let labelText = node.label;
      
        if (node.nodeType === 'act') {
          labelText = `Act ${node.label}`;
        } else if (node.nodeType === 'sequence') {
          labelText = `Seq ${node.label}`;
        } else if (node.nodeType === 'scene') {
            // NBSP padding ( ) on both sides: Plotly scales each label to
            // fit the FULL wedge, but the design-band overlay paints an opaque
            // frame over the wedge's perimeter, so glyphs reaching the band
            // zone get covered ("sc 14" reads as "sc 1"). Non-breaking spaces
            // are measured and rendered (plain spaces collapse in SVG), so the
            // fitter reserves ~2 space-widths per side and the visible glyphs
            // land inside the execution core. Symmetric so centering is
            // unchanged.
            labelText = `\u00A0\u00A0sc ${node.label}\u00A0\u00A0`;
          }
        
        // Add zoom icon only to inner rings
        // if (node.nodeType === 'act' || node.nodeType === 'sequence') {
        //   labelText += ' <span class="zoom-icon-hover" style="margin-left:6px">🔍</span>';
        // }
      
        return labelText;
      }
  
      // function createCustomData(node) {
      //   if (!node.detailedContent) return "";
        
      //   let hoverText = `<b>${node.detailedContent.title || node.label}</b><br>`;
        
      //   // Add design rating if it exists (scenes don't have it)
      //   if (node.detailedContent.design !== undefined) {
      //     const designBadge = badge(node.detailedContent.design);
      //     const designRatingText = ratingText[node.detailedContent.design] || `Rating ${node.detailedContent.design}`;
      //     hoverText += `Design: ${designRatingText} ${designBadge}<br>`;
      //   }
        
      //   // Add execution rating (all elements have this)
      //   const execBadge = badge(node.detailedContent.execution);
      //   const execRatingText = ratingText[node.detailedContent.execution] || `Rating ${node.detailedContent.execution}`;
      //   hoverText += `Exec: ${execRatingText} ${execBadge}`;
        
      //   // Add page count for scenes
      //   if (node.detailedContent.type === 'scene' && node.detailedContent.page_count) {
      //     hoverText += `<br>Pages: ${node.detailedContent.page_count}`;
      //   }
        
      //   return hoverText;
      // }

        
    function prepareChartData(ratings, includeScenes = true, metric = 'overall') {
      function scoreFor(obj, nodeType) {
        if (metric === 'overall') {
          // fall back to execution if overall missing
          return parseFloat(obj.analysis?.overallScore ?? obj.execution ?? 0);
        }
        const key = METRIC_KEYS[metric]?.[nodeType];
        const val = obj.scores?.[key]?.score;
        return parseFloat(val ?? 0);
      }
      
      // First preprocess the data to ensure all scenes have page counts
    preprocessScenes(ratings);
    
    const nodes = [];
    let totalValue = 0;
    
    // Add root node
    nodes.push({
      id: "Movie",
      parent: "",
      label: "Movie",
      value: 0, // Will update later
      color: "#eee",
      border: BORDER_ROOT,
      nodeType: "movie",
      detailedContent: {
        title: ratings.movie.title,
        description: "Complete analysis of the entire movie.",
        type: "movie",
        pcr: ratings.movie.pcr,
        execution: ratings.movie.execution,
        design: ratings.movie.design,
        execution_summary: "Overall execution score for the movie.",
        design_summary: "Overall design score for the movie."
      }
    });
    
    // Calculate a consistent gap size as a percentage of the whole
    // Make the gap narrower - reduce from 3% to 1.5%
    const gapPercentage = 0.015; // 1.5% of the total chart for the gap
    
    // Add the gap/spacer node for the "Movie" level
    nodes.push({
      id: "gap",
      parent: "Movie",
      label: "START",
      value: 1, // Temporary value, will be updated later
      color: "#000000", // Black fill
      border: "#000000", // Black border
      nodeType: "gap",
      detailedContent: {
        title: "Starting Point",
        execution_summary: "The screenplay begins here and flows clockwise.",
        type: "gap"
      }
    });
    
    // Add a child node for the gap at the sequence level
    nodes.push({
      id: "gap-seq",
      parent: "gap",
      label: "→",
      value: 1, // Temporary value
      color: "#000000",
      border: "#000000",
      nodeType: "gap"
    });
    
    // If including scenes, add a child for the scene level
    if (includeScenes) {
      nodes.push({
        id: "gap-scene",
        parent: "gap-seq",
        label: "→",
        value: 1, // Temporary value
        color: "#000000",
        border: "#000000",
        nodeType: "gap"
      });
    }
    
    // Track total ratings for movie average and for calculating actual sizes
    let totalDesign = 0;
    let totalExec = 0;
    let totalRatingItems = 0;
    let totalContentValue = 0;
    
    // Process acts in reverse order for clockwise arrangement (4,3,2,1)
    const order = [4, 3, 2, 1];
    order.forEach((num, actIndex) => {
      const act = ratings.acts.find(a => a.number === num);
      if (!act) return;
      
      const code = {1:"1", 2:"2a", 3:"2b", 4:"3"}[num];
      
      // Update total ratings
      const designRating = parseInt(act.design || 0);
      const execRating = parseInt(act.execution || 0);
      
      totalDesign += designRating;
      totalExec += execRating;
      totalRatingItems++;
      
      // Get colors based on ratings - use normal colors for fill, darker for borders
      // const fillColor = gradeColors[Math.round(parseFloat(act.analysis.overallScore || 5))];
      const actScore  = scoreFor(act, 'act');
      const fillColor = gradeColors[Math.round(actScore) || 5];      console.log("act.overallScore:", act.analysis?.overallScore);
      console.log("fillColor", fillColor);
      const borderColor = borderRatingColors[designRating] || "#999";
      
      // Add the act node
      const actNode = {
        id: `act-${code}`,
        parent: "Movie",
        label: code,
        value: 0, // Will update later
        color: fillColor,
        border: borderColor,
        actNumber: num,
        nodeType: "act",
        detailedContent: {
          title: act.title,
          analysis: act.analysis,
          scores: act.scores,
          summary: act.summary,
          id: act.id,
          description: act.design_executive_summary,
          execution: act.execution,
          execution_summary: act.execution_executive_summary,
          type: "act",
          code: code
        }
      };
      
      nodes.push(actNode);
      const actNodeIndex = nodes.length - 1;
      let actTotal = 0;
      
      // Process sequences in REVERSE order for proper clockwise arrangement
      const sequences = [...act.sequences].reverse();
      sequences.forEach((seq, seqIndex) => {
        const seqCode = `${code}-${seq.number}`;
        
        // Update total ratings
        const seqDesignRating = parseInt(seq.design || 0);
        const seqExecRating = parseInt(seq.execution || 0);
        
        totalDesign += seqDesignRating;
        totalExec += seqExecRating;
        totalRatingItems++;
        
        // Apply colors based on ratings - different colors for fill vs border
        const seqScore     = scoreFor(seq, 'sequence');
        const seqFillColor = gradeColors[Math.round(seqScore || 5)];
                // const seqFillColor =  gradeColors[Math.round(parseFloat(seq.analysis.overallScore || 5))];
        const seqBorderColor = borderRatingColors[seqDesignRating] || "#999";
        
        // Add sequence node
        const sequenceNode = {
          id: `seq-${seqCode}`,
          parent: `act-${code}`,
          label: seqCode,
          value: 0, // Will update based on scenes
          color: seqFillColor,
          border: seqBorderColor,
          actNumber: num,
          nodeType: "sequence",
          detailedContent: {
            title: seq.title,
            analysis: seq.analysis,
            id: seq.id,
            scores: seq.scores,
            summary: seq.summary,
            description: seq.design_executive_summary,
            design: seq.design,
            execution: seq.execution,
            design_summary: seq.design_executive_summary,
            execution_summary: seq.execution_executive_summary,
            type: "sequence",
            code: seqCode
          }
        };
        
        nodes.push(sequenceNode);
        const seqNodeIndex = nodes.length - 1;
        
        // Calculate sequence value
        let seqValue = 0;
        
        // Process scenes if they exist and should be included
        if (includeScenes && seq.scenes && seq.scenes.length > 0) {
          // Use REVERSE order for scenes as well for clockwise arrangement
          const scenes = [...seq.scenes].reverse();
          
          scenes.forEach((scene, i) => {
            // Use scene number as label
            const sceneLabel = `${scene.number}`;
            
            // Use page count for value, default to 1 if none provided
            const pageCount = scene.page_count || DEFAULT_PAGE_COUNT;
            
            // Use execution rating for color

            const sceneRating = parseInt(scene.execution || 0);
            // const sceneColor =  gradeColors[Math.round(parseFloat(sceneRating || 5))];
            // const sceneColor = ratingColors[sceneRating] || "#E0E0E0";
const sceneScore  = metric==='overall'
        ? parseFloat(scene.execution ?? 0)
        : parseFloat(scene.scores?.[METRIC_KEYS[metric].scene]?.score ?? 0);
  const sceneColor  = gradeColors[Math.round(sceneScore) || 5];            
            // Add scene node
            nodes.push({
              id: `scene-${code}-${seq.number}-${scene.number}`,
              parent: `seq-${seqCode}`,
              label: sceneLabel,
              value: pageCount,
              color: sceneColor,
              border: BORDER_SCENE, // Black border for scenes
              nodeType: "scene",
              detailedContent: {
                title: scene.title || `Scene ${scene.number}`,
                execution: scene.execution, // execution_0_10 — drives the inner fill
                design: scene.design ?? null, // design_0_10 — drives the outer band
                overall: scene.overall ?? null, // overall scene rating — distinct from execution
                design_execution: scene.design_execution ?? null, // verdict prose for the D&E tab
                execution_summary: scene.execution_executive_summary,
                page_count: pageCount,
                type: "scene",
                number: scene.number,
                scores: scene.scores,
                text : scene.text,
                experts_critique: scene.experts_critique,
                critique: scene.critique,
                summary: scene.summary,
                experts_suggestions: scene.experts_suggestions,
              }
            });
            
            seqValue += pageCount;
          });
        }
        
        // If no valid scenes or scenes aren't included, use a default value
        if (seqValue === 0) {
          seqValue = 1;
        }
        
        // Update sequence value
        nodes[seqNodeIndex].value = seqValue;
        actTotal += seqValue;
      });
      
      // Update act value
      nodes[actNodeIndex].value = actTotal;
      totalContentValue += actTotal;
    });
    
    // Calculate the gap size based on the total content value and desired percentage
    const gapValue = totalContentValue * gapPercentage / (1 - gapPercentage);
    
    // Update gap nodes with the calculated value
    nodes.find(node => node.id === "gap").value = gapValue;
    nodes.find(node => node.id === "gap-seq").value = gapValue;
    if (includeScenes) {
      nodes.find(node => node.id === "gap-scene").value = gapValue;
    }
    
    // Update the total value including the gap
    totalValue = totalContentValue + gapValue;
    
    // Update root node value and color based on average ratings
    nodes[0].value = totalValue;
    if (totalRatingItems > 0) {
      // Calculate and round averages
      const avgDesign = Math.round(totalDesign / totalRatingItems);
      const avgExec = Math.round(totalExec / totalRatingItems);
      
      // Apply colors based on rounded averages
      nodes[0].border = borderRatingColors[avgDesign] || BORDER_ROOT;
      nodes[0].color = ratingColors[avgExec] || "#eee";
      
      // Update root node's detailed content
      nodes[0].detailedContent.design = avgDesign;
      nodes[0].detailedContent.execution = avgExec;
    }
    
    // Apply formatted labels
    nodes.forEach(node => {
      // Special formatting for gap nodes
      if (node.nodeType === 'gap') {
        if (node.id === 'gap') {
          node.formattedLabel = "START";
        } else {
          node.formattedLabel = "→"; // Arrow indicating direction
        }
      } else {
        node.formattedLabel = formatLabel(node);
      }
    });
    
    return {
      nodes: nodes
    };
  }
  
  export { prepareChartData };
